// Filter to unique permissions
export const filterUserPermissions = (permissions: string[] | undefined): string[] =>
  permissions && permissions.length > 0
    ? permissions.filter((value, index, self) => self.indexOf(value) === index)
    : [];
